<template>
	<div :class="{ show: mounted }" class="explanation-container display-flex flex-column pa-4">
		<div>
			<Lottie class="animation-container" :width="254" :height="170" :options="interfaceAnimation" />
			<h5 class="mt-4 heavy">Interface</h5>
			<h5 class="mt-2 mb-1">A custom user facing step</h5>
			<h5 class="explanation" v-for="explanation in explanations" :key="explanation">{{ explanation }}</h5>
		</div>
		<AnemicButton @click="onDismiss" class="pa-0 width-100 ok-button mt-4" tile>Got it</AnemicButton>
		<SIcon :width="30" :height="50" class="arrow-container" name="interface-explanation-arrow" />
	</div>
</template>

<script>
import Lottie from '@/assets/lottie/lottie.vue';
import { setSeenInterfaceExplanation } from '@/store/modules/appLayout/actions.js';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'InterfaceMenuItemExplanation',
	components: { Lottie },
	computed: {
		interfaceAnimation() {
			return {
				path: `/assets/json/interface-explanation.json`,
			};
		},
	},
	methods: {
		...mapActionsShorthand({ setSeenInterfaceExplanation }),
		onDismiss() {
			this.setSeenInterfaceExplanation({ seenInterfaceExplanation: true });
		},
	},
	mounted() {
		this.mounted = true;
	},
	data: () => ({
		mounted: false,
		explanations: [
			'Ply’s superpower 🚀 Interface steps allow the user to give input at key decision points in your feature’s workflow.',
			'They are completely customizable with blocks that let the user enter data, search in other apps, select from dropdown lists, and more.',
		],
	}),
};
</script>
<style scoped lang="scss">
.explanation-container {
	opacity: 0;
	border-radius: 6px;

	background: var(--white);
	border: 1px solid var(--border-color);
	box-shadow: 0px 3px 6px var(--shadow-color);
	&.show {
		opacity: 1;
		transition: 2s;
	}
}
.ok-button {
	height: 36px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	color: #5b5be7 !important;
	font-weight: normal !important;
	text-transform: none !important;
	background: var(--bg-color) !important;
	border: 1px solid #5b5be7 !important;
}
.animation-container {
	border-radius: 10px;
}
.explanation {
	opacity: 0.5;
}
.arrow-container {
	top: -350px;
	right: -259px;
	position: absolute;
}
</style>
